export default __webpack_public_path__ + "static/media/other-diseases.ea50bcb0.jpg";